import React from "react";
import PropTypes from "prop-types";
import { pick } from "lodash";
import Resource from "common/components/Resource";
import Panel from "common/components/Panel";
import { withUrlResource } from "common/utils";
import { transformApiError } from "common/api/errors";
import client from "common/admin/client";
import ServiceForm from "./Form";
import { useTranslation } from "react-i18next";
import { localStorage } from "common/storage";

const handleSubmit = (buildingId, serviceId) => async (values, form) => {
  const body = pick(
    values,
    "category",
    "title",
    "body",
    "location",
    "hours",
    "image"
  );
  const { setSubmitting, setErrors, setStatus } = form;

  try {
    const formData = new window.FormData();

    // Append the picked values to FormData
    Object.keys(body).forEach((key) => {
      // Append the image file directly to FormData
      if (key === "image" && body[key] && body[key] instanceof File) {
        formData.append("media_metadata", body[key]); // Ensure image is properly appended
      } else {
        formData.append(key, body[key]); // Append the other fields
      }
    });

    await client.patch(`buildings/${buildingId}/services/${serviceId}`, {
      body: formData,
    });
    setStatus({ success: true });
  } catch (error) {
    const apiError = transformApiError(error);
    if (apiError.empty()) {
      setErrors({ http: error.message });
    } else {
      setErrors(apiError.object());
    }
  }
  setSubmitting(false);
};

const EditService = ({ urlResource, match }) => {
  const { t } = useTranslation();
  const ishilo = localStorage.getItem("HILO") === "true";

  return (
    <Resource
      name={`buildings/${urlResource.id}/services`}
      resourceId={match.params.serviceId}
      render={(service) => {
        // Check if media_metadata exists and has at least one image
        const imageUrl =
          service.media_metadata && service.media_metadata.length > 0
            ? service.media_metadata[0].url
            : "";

        return (
          <Panel title={t("services_create.edit_title")}>
            <ServiceForm
              isEdit
              handleSubmit={handleSubmit(
                urlResource.id,
                match.params.serviceId
              )}
              initialValues={{
                category: service.category || "",
                title: service.title || "",
                body: service.body || "",
                location: service.location || "",
                hours: service.hours || "",
                image: imageUrl, // Use the first image or placeholder
                ishilo,
              }}
            />
          </Panel>
        );
      }}
    />
  );
};

EditService.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      serviceId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  urlResource: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default withUrlResource(EditService);
